import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FlowroomLandingPage from './LandingPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<FlowroomLandingPage />} />
        <Route path="/signin" element={<div>Sign In Page</div>} />
        <Route path="/signup" element={<div>Sign Up Page</div>} />
        <Route path="/apps" element={<div>Apps Page</div>} />
        <Route path="/room/new" element={<div>New Room Page</div>} />
        <Route path="/support" element={<div>Support Page</div>} />
        <Route path="/pricing" element={<div>Pricing Page</div>} />
        <Route path="/templates" element={<div>Templates Page</div>} />
        <Route path="/privacy" element={<div>Privacy Page</div>} />
      </Routes>
    </Router>
  );
}

export default App;
